
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import importar from './lista-buscador-importar.vue';
    import presets from './lista-buscador-presets.vue';
import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            presets,
            importar,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;

        public Archivo: File = null;
        public SeleccionarArchivo: boolean = false;
        public Cargando: boolean = false;


        public async CargarManual()
        {
            this.$router.push('/pedidos/nuevo/plataformas')
        }
        public async AbrirArchivo()
        {
            this.Controlador.Vista.Estado = 'iniciado';
            this.Archivo = null;
            this.$nextTick( () =>
            {
                this.SeleccionarArchivo = !this.SeleccionarArchivo;
            })

        }
        public async AgregarArchivo( archivo: File )
        {
            if ( !archivo )
                return;
            this.Archivo = null;
            this.Cargando = true;
            await Wait( 100 );
            let e = await this.Controlador.ComprobarArchivo( archivo );
            if ( e )
            {
                this.Archivo = archivo;
            }
            this.Cargando = false;
        }

    }
